import Const from 'constants';
import Action from 'actions';
import {sortArrayOfObjects} from 'helpers/common-helper';
import LateswapCsvPlayer from 'components/organisms/late-swap/services/player-view/lateswap-csv-player';
import LateswapCsvLineup from 'components/organisms/late-swap/services/lineup-view/lateswap-csv-lineup';
import {replaceReoptimizedLineupsInCsvData} from 'components/organisms/late-swap/helpers';
import {getPlayerService} from 'services/sports/factory';
import {createCsvContent, downloadCsvFile} from 'services/csv/creator';
import OptimizedLineupsViewFactory from 'components/organisms/lineups-dashboard/services/optimized-lineups-view/factory';

function generateCsvFileName() {
    const timestamp = new Date().getTime();

    return 'lineups-' + timestamp + '.csv';
}

let LineupsDashboard = {
    downloadReoptimizedLineups() {
        return (dispatch, getSate) => {
            const {
                lineupsData: {lineups, rawLineups},
                sportConfig,
                lateSwap: {uploadedCsvData, csvLineups: lateswapCsvLineups},
            } = getSate();
            const PlayerService = getPlayerService(sportConfig);

            const reoptimizedLineups = lateswapCsvLineups.getAllAsArr().map((lateswapCsvLineup) => {
                const rawLineup = rawLineups.getLineupByEntryId(lateswapCsvLineup.getEntryId());

                if (!rawLineup) {
                    return lateswapCsvLineup;
                }

                const lineup = lineups.getLineup(rawLineup.getId());

                if (!lineup) {
                    return lateswapCsvLineup;
                }

                const lineupPlayers = Object.values(lineup.players);

                const players = [];
                lateswapCsvLineup.getPlayers().map((player, index) => {
                    const lineupPlayer = lineupPlayers[index];
                    const preparedPlayer = PlayerService.exec(
                        'preparePlayerDataForDownloading',
                        {
                            player: lineupPlayer,
                        },
                        {},
                    );

                    players.push(new LateswapCsvPlayer(preparedPlayer.id, player.getLineupPosition(), lineupPlayer));
                });

                return new LateswapCsvLineup(
                    lateswapCsvLineup.getLineupId(),
                    lateswapCsvLineup.getEntryId(),
                    lateswapCsvLineup.getDetails(),
                    [...players],
                );
            });

            const csvData = replaceReoptimizedLineupsInCsvData(
                uploadedCsvData.getAllAsArr(),
                reoptimizedLineups,
                sportConfig,
            );

            const csvContent = createCsvContent(csvData, {
                cellDelimiter: Const.LATESWAP_CSV_CELL_SEPARATOR,
                rowDelimiter: Const.LATESWAP_CSV_ROW_SEPARATOR,
            });

            downloadCsvFile(csvContent, generateCsvFileName());
        };
    },

    downloadCheckedLineups() {
        return (dispatch, getSate) => {
            const {
                lineupsData: {lineups, filters},
                sportConfig,
            } = getSate();

            const sortedLineups = sortArrayOfObjects(Object.values(lineups.all()), filters.sort, filters.sortDirection);

            const checkedLineups = [];
            const PlayerService = getPlayerService(sportConfig);
            Object.values(sortedLineups).map((lineup) => {
                if (!lineup.checked) {
                    return;
                }

                const players = PlayerService.exec('preparePlayersDataForDownloading', {players: lineup.players}, {});

                checkedLineups.push(players);
            });

            if (isEmpty(checkedLineups)) {
                return;
            }

            const view = OptimizedLineupsViewFactory.getView(sportConfig);
            const csvData = view.makeView(checkedLineups);
            const csvContent = createCsvContent(csvData);

            downloadCsvFile(csvContent, generateCsvFileName());
        };
    },

    removeCheckedLineups() {
        return (dispatch, getState) => {
            let state = getState();
            let lineups = [];

            for (const [key, value] of Object.entries(state.lineupsData.lineups.all())) {
                if (value.checked) {
                    lineups.push(key);
                }
            }

            dispatch({
                type: Const.LINEUPS_LIST_REMOVE_CHECKED,
                data: lineups,
            });
            dispatch(this.setLineupsUsedPlayers());
        };
    },
};

export default Object.assign(Action, LineupsDashboard);
